import { render, staticRenderFns } from "./HorizontalBarChart.vue?vue&type=template&id=a8ab6d42&"
import script from "./HorizontalBarChart.vue?vue&type=script&lang=js&"
export * from "./HorizontalBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports